import React, { useState } from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import ChannelsLanguageChart from '../../../Performance/components/ChannelsLanguageChart';
import { mentionsIcons } from '../../constants';
import { useHistory, useIntl } from 'umi';
import { useDrilldownParams } from '@op/hooks/useDrilldownParams';
import { isStatsDetail } from '../../utils';

const titleMap: any = {
  topic: 'Timeline of Top 15 Topics',
  keyword: 'Timeline of Top 10 Mentions',
};
export default function TimelineOfMentionsCharts({
  data,
  filter,
  loading,
  dataType,
  isVersion,
  lang,
  handleStatsDetailOnClick,
  type = 'line',
  regionType,
}: any) {
  const statsDetailType = 'stats-timeline-of-mentions';
  const history = useHistory();
  const { goPage } = useDrilldownParams();

  const { formatMessage } = useIntl();

  const [activeMentions, setActiveMentions] = useState<'line' | 'bar'>(type);

  const isDetail = isStatsDetail(history);

  return (
    <CardCommon
      title={formatMessage({
        id: titleMap[dataType] || 'Timeline of Mentions',
      })}
      bodyStyle={{ height: 375 }}
      defaultOperation={activeMentions}
      hasTitleArrow={!isDetail}
      handleTitleOnClick={() => {
        if (isDetail) {
          return;
        }
        goPage({
          path: '/opinion/Stats/Detail',
          filter: {
            filter,
            statsDetailType,
            statsDetailChartsData: {
              data,
              dataType,
              isVersion,
              regionType,
            },
          },
        });
      }}
      operations={mentionsIcons}
      handleOperationsOnClick={(item) => {
        setActiveMentions(item.symbol as any);
      }}
    >
      <div className="echart-data">
        <ChannelsLanguageChart
          dataType={dataType}
          data={data}
          showTitle={false}
          loading={loading}
          filter={filter}
          lang={lang}
          isVersion={isVersion}
          type={activeMentions}
          statsDetailType={statsDetailType}
          handleStatsDetailOnClick={handleStatsDetailOnClick}
          regionType={regionType}
        ></ChannelsLanguageChart>
      </div>
    </CardCommon>
  );
}
